export function connectionFailure(error, online = typeof navigator === "undefined" || navigator.onLine) {
  const code = String(error?.code || "").toLowerCase();
  if (/app.?check|permission-denied|unauthenticated/.test(code)) return "verification";
  if (!online || /unavailable|deadline-exceeded|network-request-failed/.test(code) ||
      /network|failed to fetch|offline|load.*chunk|chunkloaderror|dynamically imported module/i.test(`${error?.name} ${error?.message}`)) return "connection";
  return "unknown";
}
